import { graphql, useStaticQuery } from 'gatsby';

export const useGetDrupalCustomConfig = () =>
  useStaticQuery(graphql`
    query {
      customDrupalConfig {
        node__breed {
          related_product_section_title {
            en
            es
          }
          tags_section_title {
            en
            es
          }
        }
      }
    }
  `).customDrupalConfig as ICustomDrupalConfig;
